export var TransferTransactionStatusType;
(function (TransferTransactionStatusType) {
    TransferTransactionStatusType[TransferTransactionStatusType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    TransferTransactionStatusType[TransferTransactionStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    TransferTransactionStatusType[TransferTransactionStatusType["FAIL"] = 3] = "FAIL";
    TransferTransactionStatusType[TransferTransactionStatusType["FAIL_THIRD_PARTY"] = 4] = "FAIL_THIRD_PARTY";
    TransferTransactionStatusType[TransferTransactionStatusType["ERROR"] = 6] = "ERROR";
})(TransferTransactionStatusType || (TransferTransactionStatusType = {}));
//# sourceMappingURL=TransferTransactionStatusType.js.map